import { NotificationEntitiesType } from '@notifications/models/notification-entities-type';
import { NotificationStatus } from '@notifications/models/notification-status';
import { NotificationType } from '@notifications/models/notification-type';

export const LOP_NOTIFICATIONS: NotificationEntitiesType = {
  [NotificationType.LopItemAttachmentsDownload]: {
    messages: {
      [NotificationStatus.InProgress]: {
        title: 'Generating ZIP',
        message:
          '<b>[#{{lopItemName}}]</b> item attachments ZIP is being generated'
      },
      [NotificationStatus.Completed]: {
        title: 'ZIP generated',
        message: '<b>[#{{lopItemName}}]</b> item attachments ZIP is available'
      },
      [NotificationStatus.Failed]: {
        title: 'Generating ZIP failed',
        message:
          'Generating <b>[#{{lopItemName}}]</b> item attachments ZIP failed'
      },
      [NotificationStatus.Unavailable]: {
        title: 'Connectivity issues',
        message:
          '<b>[#{{lopItemName}}]</b> item attachments ZIP generation status unknown, retrying'
      }
    },
    label: 'Download ZIP'
  }
};
